import React, { useEffect } from 'react';
import { NavLink } from "react-router-dom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import style from './object.css';
import { blueGrey } from '@mui/material/colors';
import Grid from '@material-ui/core/Grid';

const Object2 = () => {
  const [clicked, setClicked] = React.useState(true);
  const color = blueGrey[900];


  let tg = window.Telegram.WebApp;
  tg.MainButton.hide()


  useEffect(() => {
    window.scrollTo(0, 0)

  }, [])

  const obj = [
    {img: "s-b.jpg",
    title: "Серебряный Бор",
    title2: "участок 38,83 сотки",
    description: "Земельный участок расположен в заповедном парке, вдоль Москвы-реки и в окружении вековых сосен. Локация позволяет легко сочетать загородный и городской образ жизни. 20 минут до центра Москвы."
    },
    // {img: "usp.jpg",
    // title: "Успенские дачи-1",
    // title2: "участок 11,87 сотки",
    // description: "Старинный дачный поселок в окружении вековых хвойных лесов с высоко-экологичными условиями для жизни и отдыха. Развитая инфраструктура Рублево-Успенского шоссе, круглосуточно охраняемая территория. 20 км от МКАД."
    // },
    {img: "p-d.jpg",
    title: "Пансионат «Петрово-Дальнее»",
    title2: "участок 23,38 сотки",
    description: "Уникальное предложение в закрытом поселке на территории пансионата. Великолепные пейзажи, абсолютная приватность, тишина и чистейший воздух на берегу реки Истра. 15 км от Москвы."
    },
    {img: "nik-s.jpg",
    title: "Никольская Слобода",
    title2: "участок 75 соток",
    description: "Земельный участок в окружении живописного хвойно-лиственного леса. На закрытой территории есть вся необходимая инфраструктура высокого уровня: детские сады, школа, теннисные корты. 10 км от МКАД по Новорижскому шоссе."
    },
    {img: "nik-g.jpg",
    title: "Николина гора",
    title2: "участок 46,39 соток, дом 1 175,7 м²",
    description: "Дом с земельным участком расположен в закрытом поселке «Николина гора». Выполнен по индивидуальному проекту из натурального соснового бруса с применением высококачественных технологий HONKA. 22 км от МКАД."
    },
    // {img: "ik.jpg",
    // title: "ИК-проект, Жуковка",
    // title2: "участок 130 соток",
    // description: "Земельный участок с домом расположен в Жуковке. Закрытый поселок «ИК-проект» находится на берегу Москвы-реки, в окружении соснового леса. Максимальная камерность, приватность и безопасность. 10 км от МКАД."
    // }
  ]

  return (
    <Grid container direction="column" alignItems="center" style={{ justifyContent: "center" }}>
      <Box sx={{ p: 3 }} alignItems="center">
      {obj.map((res, index) => (
        <Card sx={{ maxWidth: 345, mb: 3, pb: 1 }} key={index}>
          <CardMedia
            component="img"
            height="320"
            image={`../../img/${res.img}`}
            alt={res.img}
          />
          <CardContent>
             <Typography  style={{textTransform: "uppercase"}}>
           {res.title}
            </Typography>
            <Typography  style={{}}>
             {res.title2}
            </Typography>
            <br></br>
            <Typography variant="body2" color="text.secondary" style={{}}>
            {res.description}
            </Typography>
          </CardContent>
        </Card>
      ))}
        
      
      </Box>

    </Grid>
    // <Box sx={{ width: '100%' }} >
    //   <Stack sx={{p:3}} alignItems="center">
    //     <img src='../../img/MB15.png' alt="Logo" width="300"/>
    //     <p>КЛУБНЫЙ ДОМ НА ПАТРИАРШИХ</p>


    //   <ImageList
    //   sx={{ width: 400, height: 450 }}
    //   variant="quilted"
    //   cols={4}
    //   rowHeight={121}
    // >
    //   {itemData.map((item) => (
    //     <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
    //       <img
    //         {...srcset(item.img, 121, item.rows, item.cols)}
    //         alt={item.title}
    //         loading="lazy"
    //       />
    //     </ImageListItem>
    //   ))}
    // </ImageList>


    //   </Stack>

    //   </Box>
  );
};




export default Object2;